import { decisioningStudioAgentsAppGroupIdDsaIdDimensions } from "../decisioningStudioAgentsAppGroupIdDsaIdDimensions/constants";
import { decisioningStudioAgentsAppGroupIdDsaIdDimensionsDimension } from "../decisioningStudioAgentsAppGroupIdDsaIdDimensionsDimension/constants";
import type { AllRouteEndpoints } from "../routeTypes";

export const decisioningStudioAgentsAppGroupIdDsaIdDimensionsDimensionActions =
  "/decisioning_studio_agents/:app_group_id/:dsa_id/dimensions/:dimension/actions" as const;

/** An action bank write changes the dimension's own action list, and both the
 *  dimension read and the dimension-list read carry action counts derived from
 *  it, so all three go stale together. */
export const decisioningStudioAgentsAppGroupIdDsaIdDimensionsDimensionActionsCacheKeys: AllRouteEndpoints[] = [
  decisioningStudioAgentsAppGroupIdDsaIdDimensions,
  decisioningStudioAgentsAppGroupIdDsaIdDimensionsDimension,
  decisioningStudioAgentsAppGroupIdDsaIdDimensionsDimensionActions,
];
